"use strict";

exports.__esModule = true;
exports.buildTagByValueAndIdentifier = buildTagByValueAndIdentifier;
exports.buildTagByValueAndSchema = buildTagByValueAndSchema;

var _TagSchemas = require("../../types/TagSchemas");

var _isEmpty = require("../../utils/is-empty");

function buildTagByValueAndIdentifier(value, identifier, enableValidation, tagLabel) {
  if (tagLabel === void 0) {
    tagLabel = null;
  }

  var tagSchema = tagLabel ? _TagSchemas.TAG_SCHEMAS[identifier](tagLabel) : _TagSchemas.TAG_SCHEMAS[identifier];
  return buildTagByValueAndSchema(value, tagSchema, enableValidation);
}

function buildTagByValueAndSchema(value, tagSchema, enableValidation) {
  if ((0, _isEmpty.isEmpty)(tagSchema)) {
    return {};
  }

  var tag = {
    type: tagSchema.type
  };

  if (tagSchema.props) {
    tag.props = Object.assign({}, tagSchema.props);
  }

  var _tagSchema$setValue = tagSchema.setValue(tag, value, enableValidation),
      isValid = _tagSchema$setValue.isValid;

  return isValid ? tag : {};
}